<template>
  <div>
    <!-- P1 -->
    <div v-show="showP1">
      <AddRoleP1 ref='addRoleP1' @childProps='addRoleProps1'></AddRoleP1>
    </div>
    <!-- P2 -->
    <div v-show="showP2">
      <AddRoleP2 ref='addRoleP2' @childProps='addRoleProps2'></AddRoleP2>
    </div>
    <!-- P3 -->
    <div v-show="showP3">
      <AddRoleP3 ref='addRoleP3' @childProps='addRoleProps3'></AddRoleP3>
    </div>
  </div>
</template>

<script>
import AddRoleP1 from "./AddRoleP1";
import AddRoleP2 from "./AddRoleP2";
import AddRoleP3 from "./AddRoleP3";

export default {
  name: "AddRole",
  props:{
    index: Number
  },
  data() {
    return {
      roleProps1: {}, // roleName, description, selected
      roleProps2: {}, // nodeDomain, permission --------[id]
      roleProps3: {}, // 参数待定 TODO
      showP1:true,
      showP2:false,
      showP3:false,
    };
  },
  methods: {
    addRoleProps1(data){
      this.roleProps1 = data;
      this.setChildProps();
    },
    addRoleProps2(data){
      this.roleProps2 = data;
      this.setChildProps();
    },
    addRoleProps3(data){
      this.roleProps3 = data;
      this.setChildProps();
    },
    setChildProps(){
      this.$emit("childProps",{
        roleProps1: this.roleProps1,
        roleProps2: this.roleProps2,
        roleProps3: this.roleProps3
      });
    },
    init(){
      let roleObj1 = this.$refs.addRoleP1;
      let roleObj2 = this.$refs.addRoleP2;
      let roleObj3 = this.$refs.addRoleP3;

      roleObj1.queryRole();
      roleObj2.initTreeData();
      roleObj3.getNeList();

      this.bindValidate();
    },
    bindValidate(){
      this.$refs.addRoleP1.bindValidate();
    },
    validation() {
      return this.$refs.addRoleP1.validation();
    }
  },
  components: {
    AddRoleP1,
    AddRoleP2,
    AddRoleP3
  },
  watch:{
    index(){
      if(this.index === 0){
        this.showP1 = true;
        this.showP2 = false;
        this.showP3 = false;
      }else if(this.index === 1){
        this.showP1 = false;
        this.showP2 = true;
        this.showP3 = false;
      }else{
        this.showP1 = false;
        this.showP2 = false;
        this.showP3 = true;
      }
    }
  }
};
</script>